<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <GrocerTabLinks />

                    <ImportPage :id="entity.id" type="grocery" />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js';

    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import ImportPage from '@/components/import/ImportPage';

    export default {
        components: {
            GrocerTabLinks,
            ImportPage,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id;

                const [error, result] = await to(this.axios.get(`/grocers/${id}`));
                this.entity = result.data;

                if (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
        },
    };
</script>
